import { render } from "./ButtonNr4.vue?vue&type=template&id=5fc040fb&scoped=true"
import script from "./ButtonNr4.vue?vue&type=script&lang=js"
export * from "./ButtonNr4.vue?vue&type=script&lang=js"

import "./ButtonNr4.vue?vue&type=style&index=0&id=5fc040fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc040fb"]])

export default __exports__